import combineReducersNamed from '../util/reducers/combineReducersNamed';
import entityViewReducer from './view/entityViewReducer';
import withLoadingCount from '../util/withLoadingCount';
import {
  GET_STATIC_CONTENT,
  SET_HUB_CONTENT_NOT_FOUND,
  CLEAR_HUB_CONTENT_NOT_FOUND,
} from '../actions/resources/staticContentActions';

const hubContentNotFoundReducer = (state = false, action) => {
  if (action.type === SET_HUB_CONTENT_NOT_FOUND) {
    return true;
  }

  if (action.type === CLEAR_HUB_CONTENT_NOT_FOUND) {
    return false;
  }

  return state;
};

export default combineReducersNamed({
  page: withLoadingCount(entityViewReducer, GET_STATIC_CONTENT),
  hubContentNotFound: hubContentNotFoundReducer,
});
